(() => {
  'use-strict';

  let timeout;
  let prevBreakpoint = null;
  let breakpoint = null;

  /// Available breakpoints and their min width
  const breakpointsDefinition = {
    mobile: 320,
    'mobile-large': 375,
    tablet: 768,
    desktop: 1024,
    'desktop-large': 1280,
    'desktop-x-large': 1440,
    'desktop-xx-large': 1680,
  };

  window.breakpointsDefinition = breakpointsDefinition;

  const setViewportWidth = (initial = false) => {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const breakpoints = [];

    /// Compare view port width with breakpoints min widths to get the correct breakpoint
    Object.keys(breakpointsDefinition).forEach((breakpointKeyName) => {
      const breakpointMinWidth = breakpointsDefinition[breakpointKeyName];
      if (viewportWidth >= breakpointMinWidth) {
        breakpoint = breakpointKeyName;
        breakpoints.push(breakpointKeyName);
      } else {
        return false;
      }
      return true;
    });

    /// check if breakpoint change
    if (breakpoint !== null && breakpoint === prevBreakpoint) {
      return false;
    }
    /// Init prevBreakpoint or change his value if necessary
    prevBreakpoint = breakpoint;
    /// Send a breakpointChange event
    const event = new CustomEvent('breakpointChange', {
      detail: {
        breakpoint,
        breakpoints,
        viewportWidth,
        initial,
      },
    });
    document.dispatchEvent(event);
    return true;
  };

  // Set our initial width and send the initial breakpoint event
  window.onload = () => {
    setViewportWidth(true);
  };

  /// On resize events, get again the breakpoint and send a breakpointChange event
  window.addEventListener('resize', () => {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }
    /// Wrap this in requestAnimantionFrame to avoid performances issues
    timeout = window.requestAnimationFrame(() => {
      setViewportWidth(false);
    });
  }, false);
})();
